<template>
  <footer class="site-footer">
    <a :href="exatomUrl" class="site-footer-brand" target="_blank" rel="noopener" aria-label="Exatom">
      <exatom-logo inverse :width="104" />
      <span class="site-footer-pill">Score</span>
    </a>
    <p class="site-footer-text">A form optimisation tool by Exatom. Cookieless, no personal data, ISO 27001.</p>
    <nav class="site-footer-links" aria-label="Footer">
      <a :href="exatomUrl" target="_blank" rel="noopener">exatom.io</a>
      <a :href="privacyUrl" target="_blank" rel="noopener">Privacy</a>
      <a :href="termsUrl" target="_blank" rel="noopener">Terms</a>
    </nav>
  </footer>
</template>

<script>
import ExatomLogo from './ExatomLogo.vue'
import { EXATOM_URL, PRIVACY_URL, TERMS_URL } from '../score/links'

export default {
  name: 'SiteFooter',
  components: { ExatomLogo },
  data () {
    return { exatomUrl: EXATOM_URL, privacyUrl: PRIVACY_URL, termsUrl: TERMS_URL }
  }
}
</script>

<style scoped>
.site-footer {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 40px var(--ex-page-gutter);
  background: var(--ex-color-dark);
  color: var(--ex-color-neutral-300);
  font-size: 14px;
}

.site-footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.site-footer-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--ex-radius-pill);
  background: var(--ex-color-on-dark-subtle);
  color: var(--ex-color-white);
  font-size: 12px;
  font-weight: 600;
}

.site-footer-text {
  margin-left: 24px;
}

.site-footer-links {
  display: flex;
  gap: 20px;
  margin-left: auto;
}

.site-footer-links a {
  color: var(--ex-color-neutral-100);
  text-decoration: none;
}

.site-footer-links a:hover {
  color: var(--ex-color-white);
  text-decoration: underline;
}

@media (max-width: 960px) {
  .site-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 32px 16px;
  }

  .site-footer-text,
  .site-footer-links {
    margin-left: 0;
  }
}

@media print {
  .site-footer {
    display: none;
  }
}
</style>
